import { useEffect } from 'react'

export default function useEventListener(
  eventName,
  listener,
  observableArray = [],
  ref = null
) {
  useEffect(() => {
    const listenerRef = ref?.current ?? window
    listenerRef.addEventListener(eventName, listener)

    return () => {
      listenerRef.removeEventListener(eventName, listener)
    }
  }, observableArray)
}
